//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('customerBusCos', {
//        templateUrl: 'views/components/views/customerBusCos/customerBusCos.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'customerBusCosService', function ($stateParams, utilityService, customerBusCosService) {
//            const vm = this;
//            let custNo = $stateParams.cust_no;
    		
//            function setCustomerBusCosView(id) {
//                vm.model.bgCustomerBusCos.selected = vm.model.setting.gb_customerbuscos = id;
//            }

//            vm.model = {
//                bgCustomerBusCos: {
//                    selected: 'USED',
//                    buttons: [
//                        { id: 'USED', label: 'gb_customerbuscos_used', color: 'primary', onClick: { click: setCustomerBusCosView, id: 'USED' } },
//                        { id: 'ALL', label: 'gb_customerbuscos_all', color: 'primary', onClick: { click: setCustomerBusCosView, id: 'ALL' } }
//                    ]
//                },
//                setting: {},
//                itemsListCustomerCompanies: []
//            };

//            async function loadSetting() {
//                vm.model.setting = (await customerBusCosService.getCustomerBusCos({ cust_no: custNo }))[0];
//            }
            
//            async function loadCustomerCompanies() {
//                if (utilityService.validateParmsValue(vm.model.setting.cust_no, true) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.gb_customerbuscos) !== true) return;

//                return vm.model.itemsListCustomerCompanies = await customerBusCosService.listCustomerCompanies({
//                    cust_no: vm.model.setting.cust_no,
//                    gb_customerbuscos: vm.model.setting.gb_customerbuscos
//                });
//            }
            
//            vm.selectBgCustomerBusCos = function (item) {
//                vm.model.bgCustomerBusCos.selected = item;
//                vm.model.setting.gb_customerbuscos = vm.model.bgCustomerBusCos.selected;

//                loadCustomerCompanies();
//            }

//            vm.$onInit = async function () {
//                await loadSetting();
//                setCustomerBusCosView(vm.model.setting.gb_customerbuscos);
//                loadCustomerCompanies();
//            }
//        }]
//    });
//})();
